import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { getUserLanguage } from '../utils/language';
import { IMAGE_BASE_URL } from '../config';

const NotFound = () => {
  const language = getUserLanguage();

  useEffect(() => {
    document.title = language === 'cs' 
      ? '404 - Stránka nenalezena | NO RISK NO DRIFT' 
      : '404 - Page Not Found | NO RISK NO DRIFT';
  }, [language]);

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-4 py-12">
      <div className="text-center max-w-xl">
        <h1 className="text-6xl md:text-8xl font-title font-bold text-white mb-4">
          4<span className="text-red-600">0</span>4
        </h1>
        
        <div className="w-20 h-1 bg-red-600 mx-auto mb-6"></div>
        
        <h2 className="text-2xl md:text-3xl font-title font-bold text-white mb-6">
          {language === 'cs' ? 'Stránka nenalezena' : 'Page Not Found'}
        </h2>
        
        <p className="text-gray-400 mb-8">
          {language === 'cs' 
            ? 'Zdá se, že jste zabočili do únikové zóny. Tahle stránka neexistuje nebo byla přesunuta.' 
            : 'It seems you’ve drifted into the escape zone. This page doesn’t exist or has been moved.'}
        </p>
        
        <img 
          src="/images/404-drift.png" 
          alt={language === 'cs' ? 'Drift 404' : 'Drift 404'} 
          className="max-w-xs mx-auto mb-8"
        />
        
        <Link to="/" className="btn-drift">
          <i className="fas fa-home text-xs mr-2"></i>
          {language === 'cs' ? 'Zpět na domovskou stránku' : 'Back to Homepage'}
        </Link>
      </div>
      
      <div className="absolute bottom-8 left-0 w-full">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <Link to="/" className="inline-block">
              <img 
                src={`${IMAGE_BASE_URL}/images/logo-A2.png`} 
                alt="NO RISK NO DRIFT Logo" 
                className="h-10 w-auto" 
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;